// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DomUtils from "../../utils/DomUtils.bs.jsx";
import * as Reactfire from "reactfire";
import * as AppStorage from "../../utils/AppStorage.bs.jsx";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Firestore from "firebase/firestore";

let initializedFirestore = {
  contents: undefined
};

function FirebaseFirestoreProvider(props) {
  let isStandaloneModeStatus = DomUtils.useIsStandaloneMode();
  let match = Reactfire.useInitFirestore(async app => {
    let firestore = initializedFirestore.contents;
    if (firestore !== undefined) {
      return Primitive_option.valFromOption(firestore);
    }
    let isStandaloneMode = Stdlib_Option.getOr(isStandaloneModeStatus.data, false);
    let firestore$1 = Firestore.initializeFirestore(app, !isStandaloneMode && AppStorage.getThrustDevice() === undefined ? ({}) : ({
        localCache: Primitive_option.some(Firestore.persistentLocalCache({
          tabManager: Primitive_option.some(Firestore.persistentMultipleTabManager())
        }))
      }));
    initializedFirestore.contents = Primitive_option.some(firestore$1);
    return firestore$1;
  });
  let status = match.status;
  if (status === "loading") {
    return null;
  }
  if (status !== "success") {
    return <div>
      {"Some error hapenned"}
    </div>;
  }
  let firestore = match.data;
  if (firestore !== undefined) {
    return <Reactfire.FirestoreProvider
      sdk={Primitive_option.valFromOption(firestore)}
    >
      {props.children}
    </Reactfire.FirestoreProvider>;
  } else {
    return null;
  }
}

let make = FirebaseFirestoreProvider;

export {
  initializedFirestore,
  make,
}
/* DomUtils Not a pure module */
